<mat-expansion-panel [expanded]="true" class="details-expansion-panel mat-elevation-z0" hideToggle [disabled]="true">
  <mat-expansion-panel-header>
    <mat-panel-title>
      <div class="flex flex-row mr-4">
        <h4 class="mb-0">
          {{ title() }}
        </h4>
      </div>
    </mat-panel-title>
  </mat-expansion-panel-header>
  <ng-content select="[action-area]" />

  <mat-divider class="!mb-4" />

  <ng-content />
</mat-expansion-panel>
